import type { Theme } from '../types';
import { Sparkles } from './Sparkles';

// Princess — pink-to-lavender gradient with drifting sparkles.
export const princessTheme: Theme = {
  key: 'princess',
  name: 'Prinsessa',
  tokens: {
    bodyBackground: 'linear-gradient(180deg, #fbcfe8 0%, #f9a8d4 55%, #f472b6 100%)',
    pageHeadingColor: '#831843',
    pageHeadingShadow: '0 3px 0 rgba(255, 255, 255, 0.6)',
    routineCardSurface: 'rgba(255, 255, 255, 0.7)',
    cardSurface: 'rgba(255, 255, 255, 0.85)',
    accent: '#db2777',
  },
  decoration: { kind: 'component', component: Sparkles },
  routineCardPalette: ['#fcd34d', '#f9a8d4', '#c4b5fd', '#fbcfe8', '#fde68a', '#fda4af'],
};
